import { useEffect, useRef } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import {
    splitOrderInvoicesDataAtom,
    splitOrderInvoicesPageStateAtom,
    setAtomSplitOrderInvoicesListTableViewState,
    tableFiltersAtom,
    tableStateAtom,
    tableStatsAtom,
    tableViewAtom,
} from '../split_order_invoices_list_atoms';
import { splitOrderInvoicesSearchFormAtom } from '../search/split_order_invoices_search_atoms';
import { SplitOrderInvoicesDataItem } from '../split_order_invoices_list_types';
import { tableDataVM, tableStateVM, tableStatsVM, tableViewVM } from '../../../../core/table/table_view_models';
import { splitOrderInvoicesListPageStateVM } from '../split_order_invoices_list_view_models';
import { splitOrderInvoicesSearchStateVM } from '../search/split_order_invoices_search_view_models';

export const useSplitOrderInvoicesListDestroy = (): void => {
    const atomsDestroyed = useRef(false);
    const setPageState = useSetImmerAtom(splitOrderInvoicesPageStateAtom);
    const setSearchForm = useSetImmerAtom(splitOrderInvoicesSearchFormAtom);
    const setTableState = useSetImmerAtom(tableStateAtom);
    const setTableData = useSetImmerAtom(splitOrderInvoicesDataAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    useEffect(() => {
        atomsDestroyed.current = false;
        return (): void => {
            setPageState(() => splitOrderInvoicesListPageStateVM());
            setSearchForm(() => splitOrderInvoicesSearchStateVM());
            setAtomSplitOrderInvoicesListTableViewState(atomsDestroyed.current);
            setTableState(() => tableStateVM());
            setTableData(() => tableDataVM<SplitOrderInvoicesDataItem>());
            setView(() => tableViewVM());
            setStats(() => tableStatsVM());
            setFilter(() => ({}));
            atomsDestroyed.current = true;
        };
    }, [setPageState, setSearchForm, setTableState, setTableData, setView, setStats, setFilter]);
};
